module.exports = __webpack_public_path__ + "officialStatic/img/new28.3ed367c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new28.jpg
// module id = IHYI
// module chunks = 0